// XModule
import type { XModule } from '../x-modules.types'
import type { SearchXStoreModule } from './store/types'
import { XPlugin } from '../../plugins/x-plugin'
import { searchEmitters } from './store/emitters'
import { searchXStoreModule } from './store/module'
import { searchWiring } from './wiring'

/**
 * Search {@link XModule} alias.
 *
 * @public
 */
export type SearchXModule = XModule<SearchXStoreModule>

/**
 * Search {@link XModule} implementation. This module is auto-registered as soon as you
 * import any component from the `search` entry point.
 *
 * @public
 */
export const searchXModule: SearchXModule = {
  name: 'search',
  storeModule: searchXStoreModule,
  storeEmitters: searchEmitters,
  wiring: searchWiring,
}

XPlugin.registerXModule(searchXModule)
